// extracted by mini-css-extract-plugin
export default {"academicP":"index_academicP_-Swa0"};